/* eslint-disable @typescript-eslint/no-explicit-any */
import {ConfigService} from '@stackworx/react';

const endpointUrl = (path: string) => `${ConfigService.serverUri}/${path}`;

const buildHeader = (token?: string | null) => {
  const headers = new Headers();
  headers.set('Accept', 'application/json');
  headers.set('Content-Type', 'application/json');
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return headers;
};

export default class NetworkService {
  public static getToken = async (username: string, password: string) => {
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');

    return NetworkService.post(
      'oauth/token/',
      {
        grant_type: 'password',
        password,
        username,
      },
      undefined,
      headers
    );
  };

  public static post = async (
    path: string,
    data: any,
    token?: string,
    headers: any = null
  ) => {
    const url = endpointUrl(path);
    const response = await fetch(url, {
      body: JSON.stringify({
        ...data,
      }),
      headers: headers || buildHeader(token),
      method: 'POST',
    });

    if (!response.ok) {
      try {
        const error = await response.json();
        throw new Error(error.message || 'An unexpected error occurred.');
      } catch (ex) {
        throw new Error('An unexpected error occurred.');
      }
    }
    return response.json();
  };
}
